import { setBackendDomain } from "./management";
import jwtAuthAxios from "../auth/jwtAuth";

/**
 * Get created orders logs
 * GET /api/v1/logs/created-orders
 *
 * @param {Object} params - Query parameters
 * @param {number} [params.limit] - Page size (default 50)
 * @param {number} [params.offset] - Offset for pagination
 * @param {string} [params.orderId] - Filter by order ID
 * @param {string} [params.destination] - Filter by source/destination (e.g. "woocommerce", "dsok")
 * @param {string} [params.createdAtFrom] - ISO date-time
 * @param {string} [params.createdAtTo] - ISO date-time
 * @returns {Promise<{ ok: boolean, data: { items: Array, pagination?: { total: number } } }>}
 */
export const getCreatedOrdersLogs = async ({
  limit = 50,
  offset = 0,
  orderId,
  destination,
  createdAtFrom,
  createdAtTo,
} = {}) => {
  setBackendDomain(jwtAuthAxios);

  const params = {};
  if (limit != null) params.limit = limit;
  if (offset != null) params.offset = offset;
  if (orderId !== undefined && orderId !== null && String(orderId).trim() !== "")
    params.orderId = String(orderId).trim();
  if (destination !== undefined && destination !== null && String(destination).trim() !== "")
    params.destination = String(destination).trim();
  if (createdAtFrom !== undefined && createdAtFrom !== null && createdAtFrom !== "")
    params.createdAtFrom = createdAtFrom;
  if (createdAtTo !== undefined && createdAtTo !== null && createdAtTo !== "")
    params.createdAtTo = createdAtTo;

  const { data } = await jwtAuthAxios.get("/api/v1/logs/created-orders", {
    params,
  });
  return data;
};
